import { render, staticRenderFns } from "./EditBanner.vue?vue&type=template&id=1021fc03&scoped=true"
import script from "./EditBanner.vue?vue&type=script&lang=js"
export * from "./EditBanner.vue?vue&type=script&lang=js"
import style0 from "./EditBanner.vue?vue&type=style&index=0&id=1021fc03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1021fc03",
  null
  
)

export default component.exports